import API from '../apiUtils';
import {
    CommentRequest, LikeRequestBody, MessateTypeId, PollVoteRequestBody, Product
} from '../types';

export const fetchWidgetInfo = (widgetId: string, productId: string) => {
    console.log('[fetchWidgetInfo]', { widgetId, productId, encodedProductId: btoa(productId) })
    // Encode the product id to avoid errors

    return API.get(`/widgets/${widgetId}/products?product_id=${btoa(productId)}`);
}

export const fetchComments = (productId: string, userEmail: string) => {
    return API.get(`/products/${productId}/reviews?user_email=${userEmail || ''}`);
}

export const postComment = (productId: string, comment: CommentRequest) => {
    return API.post(`/products/${productId}/reviews`, { ...comment, message_type_id: comment.message_type_id || MessateTypeId.COMMENT });
}

export const postCommentLike = (productId: string, commentId: number, body: LikeRequestBody) => {
    return API.post(`/products/${productId}/reviews/${commentId}/likes`, body);
}

export const postProduct = (product: Partial<Product>) => {
    return API.post(`/products`, product);
}

export const postInteraction = (product: Partial<Product>, interactionTime: number) => {
    return API.post(`/products/${product.id}/interactions`, { interaction_time: interactionTime });
}

//@ts-ignore
export const postPollVote = (productId: string, pollId: number, body: PollVoteRequestBody) => {
    return API.post(`/products/${productId}/polls/vote`, body);
}

export const postImage = (image: File) => {
    const formData = new FormData();
    formData.append('image', image);
    return API.postMultipartFormData('/files/images', formData);
}